import { createAction } from "@reduxjs/toolkit";
import { call, put, takeLatest } from "redux-saga/effects";
import { createRequestSaga } from "src/request/baseRequest";
import { ApiResponse, verfiyResponse } from "src/request/types";
import { setLanguages } from "./languageSlice";
import { LanguageDto } from "./types";

export const getLanguages = createAction("GET_LANGUAGES");

function* getLanguagesSaga() {
  try {
    const response: ApiResponse<LanguageDto[]> = yield call(createRequestSaga, {
      method: "GET",
      url: "/api/System/appLanguages",
    });
    if (verfiyResponse(response)) {
      yield put(setLanguages(response.Result));
    } else {
    }
  } catch (e) {
    console.log("ERROR languages Saga", e);
  }
}

const languageSaga = [takeLatest(getLanguages.toString(), getLanguagesSaga)];
export default languageSaga;
